import { render, staticRenderFns } from "./PostCategory.vue?vue&type=template&id=1fb68a24&"
import script from "./PostCategory.vue?vue&type=script&lang=js&"
export * from "./PostCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports